export default "__VITE_ASSET__b6ecb26b__"